import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message", "copyLabel"]

  open(event) {
    this.messageTarget.value = event.currentTarget.dataset.invitationMessage
    this.copyLabelTarget.textContent = "Copy invitation"
    $("#invitationLinkModal").modal("show")
  }

  async copy() {
    const message = this.messageTarget.value

    try {
      await navigator.clipboard.writeText(message)
    } catch (_error) {
      this.messageTarget.select()
      document.execCommand("copy")
    }

    this.copyLabelTarget.textContent = "Copied"
    window.setTimeout(() => {
      this.copyLabelTarget.textContent = "Copy invitation"
    }, 1800)
  }
}
